<template>
  <div class="card">
    <div class="card-body">
      <ListMenu
        :id="`${id}-menu`"
        :item="item"
        :eventBus="eventBus"
        :mobile="true"
        :section="section"
        class="card-menu"
      />
      <div class="card-details">
        <div class="card-title">{{ item.name }}</div>
        <div class="card-subtitle">
          {{ item.start_date | moment("M/D/YYYY h:mm A") }}
          {{ item.timezone_abbreviation }}
        </div>
        <div class="card-text">
          <div v-if="isVirtual && !!item.can_view_webinar">
            <div class="fs-2 text-uppercase">Webinar Details:</div>
            <div class="text-dark" v-html="item.webinar_notes"></div>
          </div>
          <p v-else-if="isInPerson">
            <span class="fs-2 text-uppercase">Location:</span>
            <br />
            <span class="text-dark" v-html="item.address"></span>
          </p>
          <p>
            <span class="fs-2 text-uppercase">Hours:</span>
            <br />
            <span class="text-dark">{{ item.hours }}</span>
          </p>
        </div>
        <slot />
      </div>
      <div v-if="!!item.is_live" class="text-center pt-3">
        <a :href="item.webinar_url" target="_blank" class="btn btn-danger"
          >LIVE - Join Now</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import ListCardMixin from "mixins/ListCard";
import ListMenu from "./ListMenu";
export default {
  mixins: [ListCardMixin],
  components: { ListMenu },
  props: {
    section: { type: String, default: "training" },
  },
  computed: {
    isInPerson() {
      return !this.item.course || !this.item.course.is_virtual;
    },
    isVirtual() {
      return !!this.item.course && !!this.item.course.is_virtual;
    },
  },
};
</script>
